/**
 * Convert Contentful markdown format to standard markdown
 * Contentful uses __ for bold, but standard markdown uses **
 * 
 * @param {string} markdown - Contentful markdown string
 * @returns {string} Standard markdown string
 */
export const convertContentfulMarkdown = (markdown) => {
  if (!markdown) return '';
  
  // Convert __text__ to **text** for bold
  // This regex handles both plain text and links within bold markers
  let converted = markdown;
  
  // For links, we'll keep them as is since we're applying bold style directly in the component
  // Just ensure the format is consistent
  
  // Handle __[text](url)__ format - convert to standard markdown
  converted = converted.replace(/__\[([^\]]+)\]\(([^)]+)\)__/g, '[$1]($2)');
  
  // Handle **[text](url)** format - keep as is for now
  // The link component will handle the bold styling
  
  // Handle all __text__ patterns - match any characters including spaces between __
  // This will handle cases like __Koodo and__
  converted = converted.replace(/__(.+?)__/g, '**$1**');
  
  // Handle strikethrough links: --[text](url)--
  converted = converted.replace(/--\[([^\]]+)\]\(([^)]+)\)--/g, '~~[$1]($2)~~');
  
  // Handle remaining strikethrough text: --text--
  converted = converted.replace(/--(.+?)--/g, '~~$1~~');
  
  return converted;
};

/**
 * Process markdown and add custom styles for links
 * 
 * @param {string} markdown - Markdown string
 * @returns {object} Options for react-showdown
 */
export const getMarkdownOptions = () => {
  return {
    tables: true,
    openLinksInNewWindow: true,
    simpleLineBreaks: true,
    strikethrough: true,
    underline: true
  };
};

/**
 * Add underline style to all links in HTML
 * 
 * @param {string} html - HTML string from markdown conversion
 * @returns {string} HTML with underlined links
 */
export const addUnderlineToLinks = (html) => {
  if (!html) return '';
  
  // Add inline style to all anchor tags
  return html.replace(
    /<a\s+([^>]*?)>/g,
    '<a $1 style="text-decoration: underline;">'
  );
};